"use client"

import type { PortfolioData } from "@/lib/api-service"

interface PortfolioSummaryProps {
  portfolio: PortfolioData
}

export function PortfolioSummary({ portfolio }: PortfolioSummaryProps) {
  const stats = portfolio.statistics
  if (!stats) {
    return null
  }

  return (
    <div className="mb-6 p-4 border rounded-lg bg-card">
      <div className="mb-4">
        {portfolio.freq !== undefined && (
          <div className="text-sm font-medium text-foreground mb-2">
            Portfolio Size: {portfolio.freq}
          </div>
        )}
        <div className="space-y-1">
          {portfolio.decile !== undefined && (
            <div className="text-sm text-muted-foreground">
              Decile: {portfolio.decile}
            </div>
          )}
          {portfolio.sic !== undefined && (
            <div className="text-sm text-muted-foreground">
              SIC Code: {portfolio.sic}
            </div>
          )}
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left p-2 font-semibold">Percentile Rank</th>
              <th className="text-left p-2 font-semibold">Annualized Std Deviation</th>
              <th className="text-left p-2 font-semibold">Liquidation Period Days</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="p-2">25th</td>
              <td className="p-2">{(stats.volatility.q1 * 100).toFixed(2)}%</td>
              <td className="p-2">{stats.halfLife.q1.toFixed(1)}</td>
            </tr>
            <tr className="border-b">
              <td className="p-2">Median</td>
              <td className="p-2">{(stats.volatility.median * 100).toFixed(2)}%</td>
              <td className="p-2">{stats.halfLife.median.toFixed(1)}</td>
            </tr>
            <tr>
              <td className="p-2">75th</td>
              <td className="p-2">{(stats.volatility.q3 * 100).toFixed(2)}%</td>
              <td className="p-2">{stats.halfLife.q3.toFixed(1)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

